// Text overlays use the existing persisted keys. Media, links and layout stay on
// the base entity; list translations are matched by stable ID, never position.
export const SITE_CONTENT_FIELDS = {
  identity: ['store_name', 'store_slogan', 'store_description'],
  legal: ['terms_html', 'privacy_html', 'refunds_html', 'shipping_html'],
  texts: ['about_text', 'whatsapp_message', 'contact_address', 'shipping_info_text', 'maintenance_message', 'seo_keywords'],
  navbar: ['navbar_links'],
  footer: ['footer_links'],
  faq: ['faqs'],
  popup: ['welcome_popup'],
  'auth-images': ['auth_carousel'],
}

export const cloneContent = value => JSON.parse(JSON.stringify(value))

export function listTranslation(config, group, id, parentId) {
  let list = config?.translations?.en?.[group] || []
  if (parentId != null) list = list.find(item => String(item.id) === String(parentId))?.children || []
  return list.find(item => String(item.id) === String(id)) || {}
}

export function setListTranslation(config, group, id, field, value, parentId) {
  config.translations ||= {}
  config.translations.en ||= {}
  config.translations.en[group] ||= []
  let list = config.translations.en[group]
  const entry = (items, key) => {
    let found = items.find(item => String(item.id) === String(key))
    if (!found) { found = { id: key }; items.push(found) }
    return found
  }
  if (parentId != null) {
    const parent = entry(list, parentId)
    parent.children ||= []
    list = parent.children
  }
  entry(list, id)[field] = value
}

export function homeItemTranslation(section, item, field) {
  const map = field === 'ctaText' ? 'itemCtaTexts' : 'itemLabels'
  return section.translations?.en?.[map]?.[item.id] || ''
}

export function setHomeItemTranslation(section, item, field, value) {
  const map = field === 'ctaText' ? 'itemCtaTexts' : 'itemLabels'
  section.translations ||= {}
  section.translations.en ||= {}
  section.translations.en[map] ||= {}
  section.translations.en[map][item.id] = value
}

export function remapItemTranslations(section, idMap) {
  for (const entry of Object.values(section.translations || {})) {
    for (const key of ['itemLabels', 'itemCtaTexts']) {
      if (!entry[key]) continue
      entry[key] = Object.fromEntries(Object.entries(entry[key])
        .filter(([id]) => idMap.has(id)).map(([id, value]) => [idMap.get(id), value]))
    }
  }
}

// Only include this group's fields; merge against fresh server translations so
// saving identity cannot replace legal/nav overlays edited in another screen.
export function siteGroupPayload(group, current, latest, baseline) {
  const fields = SITE_CONTENT_FIELDS[group] || []
  const payload = Object.fromEntries(fields.filter(key => !baseline || JSON.stringify(current[key]) !== JSON.stringify(baseline[key]?.base)).map(key => [key, cloneContent(current[key] ?? '')]))
  const overlayFields = fields.filter(key => !['welcome_popup', 'auth_carousel'].includes(key) && (!baseline || JSON.stringify(current.translations?.en?.[key]) !== JSON.stringify(baseline[key]?.translation)))
  if (overlayFields.length) {
    payload.translations = cloneContent(latest.translations || {})
    payload.translations.en ||= {}
    for (const key of overlayFields) {
      const value = current.translations?.en?.[key]
      if (value === undefined) delete payload.translations.en[key]
      else payload.translations.en[key] = cloneContent(value)
    }
  }
  return payload
}

export function designDestination(query = {}) {
  const tab = query.tab || 'identity'
  if (tab === 'categories') return { path: '/configuracion/categorias', query }
  if (tab === 'collections') return { path: '/configuracion/productos', query: { ...query, tab: 'collections' } }
  return { path: '/configuracion/diseno', query: { ...query, tab: ({ home: 'sections', welcome: 'popup' })[tab] || tab } }
}
